import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _EssayExample;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint-disable react/jsx-no-literals */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import EssayEdit from '../Edit';
import EssayShow from '../Show';
import EssayTake from '../Take';
import EssayResult from '../Result';
import generateStyle from '../../common/example/default';
import generateComponentTheme from '../../common/example/defaultTheme';
import { withStyleOverrides } from '@instructure/quiz-common';

/**
---
category: Essay
---
  Essay Example.

  ```jsx_example
    <SettingsSwitcher locales={LOCALES}>
      <EssayExample />
    </SettingsSwitcher>
  ```
**/
var EssayExample = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_EssayExample = /*#__PURE__*/function (_Component) {
  function EssayExample(props) {
    var _this;
    _classCallCheck(this, EssayExample);
    _this = _callSuper(this, EssayExample);
    _defineProperty(_this, "handleChangeItemState", function (itemState) {
      var newState = Object.assign({}, itemState, itemState.scoringData ? {
        scoredData: {
          value: _this.transformScoredData(itemState.scoringData),
          gradeStatus: 'waiting'
        }
      } : null, itemState.interactionData ? {
        takeInteractionData: _this.transformTakeInteractionData(itemState.interactionData)
      } : null);
      _this.setState(newState);
    });
    _defineProperty(_this, "handleResponseUpdate", function (userResponse) {
      _this.setState({
        userResponse: {
          value: userResponse
        },
        scoredData: {
          value: userResponse,
          gradeStatus: 'waiting'
        }
      });
    });
    _this.state = {};
    if (props.useDefaultData) {
      Object.assign(_this.state, {
        interactionData: {
          rce: false,
          spellCheck: false,
          wordCount: false,
          wordLimitEnabled: false,
          wordLimitMax: null,
          wordLimitMin: null,
          notes: ''
        },
        itemBody: 'Why did the Roman Empire fall?',
        properties: {},
        scoringData: {
          value: 'goths and food shortage'
        },
        scoredData: {
          gradeStatus: 'waiting',
          value: ''
        },
        userResponse: {
          value: ''
        }
      });
      _this.state.takeInteractionData = _this.transformTakeInteractionData(_this.state.interactionData);
    }
    return _this;
  }

  /**
   * Normally, this should be calling a service
   */
  _inherits(EssayExample, _Component);
  return _createClass(EssayExample, [{
    key: "transformScoredData",
    value: function transformScoredData(scoringData) {
      return cloneDeep(scoringData);
    }

    /**
     * Normally, this should be calling a service
     */
  }, {
    key: "transformTakeInteractionData",
    value: function transformTakeInteractionData(interactionData) {
      return cloneDeep(interactionData);
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      return jsx("div", {
        title: "edit"
      }, jsx(Heading, {
        level: "h2"
      }, "Edit"), jsx(EssayEdit, {
        changeItemState: this.handleChangeItemState,
        interactionData: this.state.interactionData,
        itemBody: this.state.itemBody,
        itemId: this.state.itemId,
        properties: this.state.properties,
        scoringData: this.state.scoringData
      }));
    }
  }, {
    key: "renderShow",
    value: function renderShow() {
      return jsx("div", {
        title: "show"
      }, jsx(Heading, {
        level: "h2"
      }, "Show"), jsx(EssayShow, {
        interactionData: this.state.interactionData,
        itemBody: this.state.itemBody,
        properties: this.state.properties,
        scoringData: this.state.scoringData
      }));
    }
  }, {
    key: "renderTake",
    value: function renderTake() {
      return jsx("div", {
        title: "take"
      }, jsx(Heading, {
        level: "h2"
      }, "Take"), jsx(EssayTake, {
        interactionData: this.state.takeInteractionData,
        itemBody: this.state.itemBody,
        userResponse: this.state.userResponse,
        handleResponseUpdate: this.handleResponseUpdate
      }));
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      return jsx("div", {
        title: "result"
      }, jsx(Heading, {
        level: "h2"
      }, "Result"), jsx(EssayResult, {
        interactionData: this.state.takeInteractionData,
        itemBody: this.state.itemBody,
        scoredData: this.state.scoredData,
        scoringData: this.state.scoringData
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.row
      }, jsx("div", {
        css: this.props.styles.panel
      }, this.renderEdit()), jsx("div", {
        css: this.props.styles.panel
      }, this.renderShow())), jsx("div", {
        css: this.props.styles.row
      }, jsx("div", {
        css: this.props.styles.panel
      }, this.renderTake()), jsx("div", {
        css: this.props.styles.panel
      }, this.renderResult())));
    }
  }]);
}(Component), _defineProperty(_EssayExample, "displayName", 'EssayExample'), _defineProperty(_EssayExample, "componentId", "Quizzes".concat(_EssayExample.displayName)), _defineProperty(_EssayExample, "propTypes", {
  useDefaultData: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_EssayExample, "defaultProps", {
  useDefaultData: true
}), _EssayExample)) || _class);
export { EssayExample as default };